import { render } from "./header.vue?vue&type=template&id=a2196b2e"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/staging2/web_head/releases/20251209235657/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__